import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { createPortal } from "react-dom";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { LexicalTypeaheadMenuPlugin, MenuOption, } from "@lexical/react/LexicalTypeaheadMenuPlugin";
import { $createMentionNode } from "./MentionNode";
import { TextNode, $getSelection, $isRangeSelection } from "lexical";
class MentionOption extends MenuOption {
    id;
    name;
    email;
    constructor(option) {
        super(option.name);
        this.id = option.id;
        this.name = option.name;
        this.email = option.email;
    }
}
const MentionsPlugin = ({ options }) => {
    const [editor] = useLexicalComposerContext();
    const mentionOptions = useMemo(() => options.map((option) => new MentionOption(option)), [options]);
    const checkForMentionMatch = (text) => {
        const match = /(^|\s)@([\p{L}0-9._-]{0,30})$/u.exec(text);
        if (match) {
            return {
                leadOffset: match.index + match[1].length,
                matchingString: match[2],
                replaceableString: match[0].slice(match[1].length),
            };
        }
        return null;
    };
    const renderMenu = (anchorElementRef, { selectedIndex, selectOptionAndCleanUp, setHighlightedIndex }) => {
        const anchorElement = anchorElementRef.current;
        if (!anchorElement)
            return null;
        return createPortal(_jsxs("div", { className: "z-50 min-w-[220px] overflow-hidden rounded-lg border border-slate-200 bg-white shadow-xl", children: [mentionOptions.length === 0 && (_jsx("p", { className: "px-3 py-2 text-sm text-slate-500", children: "Aucun utilisateur trouv\u00E9" })), mentionOptions.map((option, index) => (_jsxs("button", { type: "button", className: `flex w-full items-center justify-between px-3 py-2 text-left text-sm transition ${index === selectedIndex
                        ? "bg-blue-50 text-blue-700"
                        : "text-slate-600 hover:bg-slate-50"}`, onClick: () => {
                        selectOptionAndCleanUp(option);
                    }, onMouseEnter: () => setHighlightedIndex(index), children: [_jsx("span", { children: option.name }), option.email && (_jsx("span", { className: "text-xs text-slate-400", children: option.email }))] }, option.key)))] }), anchorElement);
    };
    return (_jsx(LexicalTypeaheadMenuPlugin, { triggerFn: checkForMentionMatch, options: mentionOptions, onQueryChange: () => undefined, menuRenderFn: renderMenu, onSelectOption: (option, nodeToReplace, closeMenu) => {
            editor.update(() => {
                const selection = $getSelection();
                if (!$isRangeSelection(selection))
                    return;
                const mentionNode = $createMentionNode(option.id, option.name);
                if (nodeToReplace) {
                    nodeToReplace.replace(mentionNode);
                }
                else {
                    selection.insertNodes([mentionNode]);
                }
                const spaceNode = new TextNode(" ");
                mentionNode.insertAfter(spaceNode);
                spaceNode.select();
            });
            closeMenu();
        } }));
};
export default MentionsPlugin;
